import { tokens } from '../../public/tokens';
import { MOBILE_MEDIA_QUERY } from './breakpoints';

const { colors, typography, globals } = tokens;

/**
 * Everything Button and TabButton share. Spread it in first, then override the
 * few properties that actually differ (padding, alignment, colors).
 */
export const buttonBase = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: globals['border-radius'],
    fontFamily: globals['font-family'],
    fontWeight: typography.fontWeights.semibold,
    fontSize: typography.fontSize['lg-14px'],
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',

    ':disabled': {
        opacity: 0.6,
        cursor: 'not-allowed',
    },

    i: {
        fontSize: typography.fontSize['base-16px'],
        lineHeight: 'inherit',
    },

    [MOBILE_MEDIA_QUERY]: {
        fontSize: typography.fontSize['md-12px'],
        whiteSpace: 'normal',
    },
};

/**
 * The neutral hover/active pair both buttons fall back to when a variant doesn't
 * define its own.
 */
export const neutralPressStates = {
    ':hover': {
        backgroundColor: colors.neutral.grey['100'],
    },
    ':active': {
        backgroundColor: colors.neutral.grey['200'],
    },
};
